// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3vl55","icon":"SortAdornment_icon__QUyZC","up":"SortAdornment_up__2qXZ4","down":"SortAdornment_down__1US0O","active":"SortAdornment_active__3gQPY"};